"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_promise_tracker_1 = require("react-promise-tracker");
const react_loader_spinner_1 = require("react-loader-spinner");
function LoadingIndicator(props) {
    const { promiseInProgress } = (0, react_promise_tracker_1.usePromiseTracker)({ area: props.area });
    return (promiseInProgress && react_1.default.createElement("div", { className: 'd-flex justify-content-center align-items-center w-100 m-3' },
        react_1.default.createElement(react_loader_spinner_1.TailSpin, { color: "blue", height: "40", width: "40" })));
}
exports.default = LoadingIndicator;
